import { render, staticRenderFns } from "./TableWithInputs.vue?vue&type=template&id=39a931f7&scoped=true"
import script from "./TableWithInputs.vue?vue&type=script&lang=js"
export * from "./TableWithInputs.vue?vue&type=script&lang=js"
import style0 from "./TableWithInputs.scss?vue&type=style&index=0&id=39a931f7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a931f7",
  null
  
)

export default component.exports